import React, { createContext, useState, useEffect } from "react";

const CategoryContext = createContext();

export const CategoryProvider = ({ children }) => {
  const [selectedCategoryId, setSelectedCategoryId] = useState(() => {
    return localStorage.getItem("selectedCategoryId");
  });

  useEffect(() => {
    if (selectedCategoryId) {
      localStorage.setItem("selectedCategoryId", selectedCategoryId);
    }
  }, [selectedCategoryId]);

  return (
    <CategoryContext.Provider
      value={{ selectedCategoryId, setSelectedCategoryId }}
    >
      {children}
    </CategoryContext.Provider>
  );
};

export default CategoryContext;
